import type { MRT_ColumnDef } from "mantine-react-table-open";
import { YesNoChoice } from "../../../../../types/api.types";
import getDateRangeString from "../../../../../utils/dates/getDateRangeString";
import type { GeneratorListItemResponse } from "../../../../ObjectModals/GeneratorModal/GeneratorModal.types";

export function getStromsteuerColumns(): Array<
  MRT_ColumnDef<GeneratorListItemResponse>
> {
  return [
    {
      header:
        "Steuerfreier Selbstverbrauch (≥ 2 MW) – § 9 Abs. 1 Nr. 1 StromStG",
      id: "stfrei_paragraph_9_abs_1_nr_1_stromstg",
      accessorFn: (row) =>
        formatStromsteuerValue(
          row.stfrei_paragraph_9_abs_1_nr_1_stromstg,
          getDateRangeString(
            row.datum_erlaubnis_stfrei_paragraph_9_abs_1_nr_1_stromstg
          )
        )
    },
    {
      header: "Steuerfreie Entnahme zur Stromerzeugung – § 9 Abs. 1 Nr. 2 ",
      id: "einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung",
      accessorFn: (row) =>
        formatStromsteuerValue(
          row.einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung,
          getDateRangeString(
            row.datum_einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung
          )
        )
    },
    {
      header:
        "Steuerfreier Selbstverbrauch ≤2 MW (räuml. Zshg.) – § 9 Abs. 1 Nr. 3a ",
      id: "stromstg_paragraph_9_1_3a",
      accessorFn: (row) =>
        formatStromsteuerValue(
          row.stromstg_paragraph_9_1_3a,
          getDateRangeString(
            row.zeitraum_stromstg_paragraph_9_1_3a?.lower,
            row.zeitraum_stromstg_paragraph_9_1_3a?.upper
          )
        )
    },
    {
      header:
        "Lieferung an Letztverbraucher ≤2 MW (räuml. Zshg.) – § 9 Abs. 1 Nr. 3b ",
      id: "stromstg_paragraph_9_1_3b",
      accessorFn: (row) =>
        formatStromsteuerValue(
          row.stromstg_paragraph_9_1_3b,
          getDateRangeString(
            row.zeitraum_stromstg_paragraph_9_1_3b?.lower,
            row.zeitraum_stromstg_paragraph_9_1_3b?.upper
          )
        )
    }
  ];
}

function formatStromsteuerValue(
  choice: YesNoChoice | null | undefined,
  dateRange: string | null
): string {
  if (choice !== YesNoChoice.yes) return "Nein";
  return dateRange ? `Ja (${dateRange})` : "Ja";
}
